import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telefone'
})
export class TelefonePipe implements PipeTransform {
  transform(value: string, ...args: any[]): any {
    if (value) {
      value = value.toString().replace(/\D/g, '');

      if (value.length > 10) {
        return value.replace(/(\d{2})?(\d{5})?(\d{4})/, '($1) $2-$3');
      }
      if (value.length > 9) {
        return value.replace(/(\d{2})?(\d{4})?(\d{4})/, '($1) $2-$3');
      }

      return '';
    } else {
      return '';
    }
  }
}
